import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Coffee } from "lucide-react";

export default function LoginPage() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("admin@cafe.com");
  const [password, setPassword] = useState("admin123");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await login(email, password);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-taupe-100">
      {/* Left: hero image */}
      <div className="relative hidden lg:block">
        <img
          alt="Cozy cafe interior"
          src="https://images.unsplash.com/photo-1613274554329-70f997f5789f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxjb3p5JTIwbW9kZXJuJTIwY2FmZSUyMGludGVyaW9yfGVufDB8fHx8MTc4MzAwNTY0MHww&ixlib=rb-4.1.0&q=85"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-espresso-900/40" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center">
              <Coffee className="w-5 h-5" />
            </div>
            <span className="font-heading font-bold text-lg tracking-tight">Brew Field</span>
          </div>
          <div>
            <h1 className="font-heading font-extrabold text-5xl leading-tight tracking-tighter">
              Run your cafe.<br />Not your spreadsheet.
            </h1>
            <p className="mt-4 text-white/80 max-w-md text-base">
              Track sales, log expenses across Blinkit, Zepto & more, and see profit at a glance — all in one warm place.
            </p>
          </div>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-8 sm:p-16">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md card-soft p-8 sm:p-10 animate-fade-in-up"
          data-testid="login-form"
        >
          <div className="mb-8">
            <div className="lg:hidden flex items-center gap-2 mb-6 text-espresso-800">
              <Coffee className="w-6 h-6" />
              <span className="font-heading font-bold text-lg">BrewField</span>
            </div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-taupe-500 mb-2">
              Welcome back
            </div>
            <h2 className="font-heading font-extrabold text-3xl tracking-tighter text-espresso-900">
              Sign in to your dashboard
            </h2>
            <p className="text-taupe-600 mt-2 text-sm">Enter your credentials to continue.</p>
          </div>

          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-espresso-800 mb-2 block">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@cafe.com"
                className="bg-taupe-100 border-taupe-200 rounded-xl h-12"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-espresso-800 mb-2 block">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="bg-taupe-100 border-taupe-200 rounded-xl h-12"
                data-testid="login-password-input"
              />
            </div>

            {error && (
              <div
                className="text-sm text-terracotta-500 bg-terracotta-100 border border-terracotta-500/20 rounded-xl px-4 py-3"
                data-testid="login-error"
              >
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={submitting}
              className="w-full h-12 rounded-xl bg-espresso-800 hover:bg-espresso-900 text-white font-semibold text-base"
              data-testid="login-submit-button"
            >
              {submitting ? "Signing in…" : "Sign in"}
            </Button>

            <div className="text-center">
              <a
                href="/forgot-password"
                className="text-sm text-taupe-600 hover:text-espresso-800 underline-offset-4 hover:underline transition-colors"
                data-testid="forgot-password-link"
              >
                Forgot your password?
              </a>
            </div>
          </div>

          <p className="text-xs text-taupe-500 mt-8 text-center">
            Default admin: <span className="font-mono">admin@cafe.com / admin123</span>
          </p>
        </form>
      </div>
    </div>
  );
}
